import styled from 'styled-components'

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`

export const XButtonWrapper = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  svg {
    cursor: pointer;
  }
`

export const SelectedConnections = styled.div`
  overflow-y: auto;
`
